import React, { Component } from "react";
import ReactDOM from 'react-dom';
import axios from "axios";
import { LangContext } from "../LangContext.jsx";
class CountryStateCity extends Component {
    constructor(props) {
        super();
        this.state = {
            countries: [],
            states: [],
            country: '',
            cities: [],
            selectedCountry: '',
			selectedState: ''
        };
        this.changeCountry = this.changeCountry.bind(this);
		this.changeState = this.changeState.bind(this);
    }

    componentDidMount() {
        this.getCountries()
    }

    async getCountries() {
        const res = await axios.get('/api/countries')
        const data = res.data
        const options = data.map(c => ({
            "value" : c.id,
            "label" : c.name
        }))
        this.setState({countries: options})
    }

    async getStates(country){
        this.setState({selectedCountry: country})
        const res = await axios.get('/api/states?country=' + country)
        const data = res.data

        const options = data.map(s => ({
          "value" : s.id,
          "label" : s.name
        }))
        this.setState({states: options})
    }

    async getCities(state){
        this.setState({selectedState: state})
        const res = await axios.get('/api/municipalities?state=' + state)
        const data = res.data

        const options = data.map(c => ({
            "value" : c.id,
            "label" : c.name
        }))
        this.setState({cities: options})
    }

    changeCountry(event) {
        this.setState({country: event.target.value})
        this.getStates(event.target.value)
	}

	changeState(event) {
		this.getCities(event.target.value)
	}

    render() {
        const { countries } = this.state
        return (
            <div className="row justify-content-center text-left">
                <div className="col-sm-4 form-group">
                    <label className="text-left font-weight-bold text-dark-light">{this.props.country_label}</label>
                    <select  id={this.props.country} name={this.props.country} placeholder={this.props.country} value={this.state.selectedCountry} onChange={this.changeCountry} className="form-control form-control-solid">
                        <option value="0">--Seleccionar--</option>
                        {this.state.countries.map((o, i) => {
                            return <option key={i} value={o.value}>{o.label}</option>;
                        })}
                    </select>
                </div>
                {this.state.selectedCountry != 2 &&
                <>
                <div className="col-sm-4 form-group">
                    <label className="text-left font-weight-bold text-dark-light">{this.props.state_label}</label>
                    <select id={this.props.state} name={this.props.state} placeholder={this.props.state} value={this.state.selectedState} onChange={this.changeState} className="form-control form-control-solid">
                        <option>--Seleccionar--</option>
                        {this.state.states.map((o, i) => {
                            return <option key={i} value={o.value}>{o.label}</option>;
                        })}
                    </select>
                </div>

                <div className="col-sm-4 form-group">
                    <label className="text-left font-weight-bold text-dark-light">{this.props.city_label}</label>
                    <select id={this.props.city} name={this.props.city} placeholder={this.props.city} className="form-control form-control-solid" required>
                        <option value="">--Seleccionar--</option>
                        {this.state.cities.map((o, i) => {
                            return <option key={i} value={o.value}>{o.label}</option>;
                        })}
                    </select>
                </div>
                </>
                }
                {this.state.selectedCountry == 2 &&
                <>
                <div className="col-sm-4 form-group">
                    <label className="text-left font-weight-bold text-dark-light">Departamento</label>
                    <input type="text"  name="state_colombia" className="form-control form-control-solid"/>
                </div>
                <div className="col-sm-4 form-group">
                    <label className="text-left font-weight-bold text-dark-light">{this.props.city_label}</label>
                    <input type="text"  name="municipio_colombia" className="form-control form-control-solid" required/>
                </div>
                </>
                }
            </div>
        );
    }
}

export default CountryStateCity;

if (document.getElementById('countryStateCity')) {
    ReactDOM.render(<CountryStateCity />, document.getElementById('countryStateCity'));
}
